module.exports = __webpack_public_path__ + "static/media/tripTrail_Nay.ea962dc1.svg";